function init() {

    // pre-populate document accordions for product pages
    if ($(".product-page")) {
        $(".product-accordion h3").each(function (index, elem) {
            //populateDocumentAccordionPanel(elem);
        });
    }

    // populate document accordions on open
    $(".product-accordion h2.accordion-header.document-accordion").click(function () {
        populateDocumentAccordionPanel(this);
    });

}

function populateDocumentAccordionPanel(accordionHeader) {
    var $accordionHeader = $(accordionHeader);
    if ($accordionHeader.hasClass('document-accordion') && !$accordionHeader.hasClass('documents-loaded')) {
        var blockId = $accordionHeader.attr("data-block");
        var pageId = $accordionHeader.attr("data-page");
        var pageLanguage = $accordionHeader.attr("data-language");
        var targetId = $accordionHeader.attr("data-target");
        $.get("/blocks/DocumentAccordionPanelBlock/Documents",
            {
                currentBlockId: blockId,
                currentPageId: pageId,
                lang: pageLanguage
            },
            function (data) {
                $accordionHeader.addClass("documents-loaded");
                $(targetId).html(data);
            }
        );
    }
}

export default {
    init,
    populateDocumentAccordionPanel
}